<template>
  <main class="main page-inside">
    <div class="cart-page">
      <div class="section cart-section">
        <div class="wrapper">
          <div class="title-container">
            <div class="title title-main">CART</div>
            <span class="desc">({{ $parent.cartContents.length }} items)</span>
          </div>
          <div class="flex">
            <div class="list" v-if="$parent.cartContents.length">
              <div
                class="item"
                v-for="(item, i) in $parent.cartContents"
                :key="i"
              >
                <img
                  src="../img/corners3/top-left-corner.svg"
                  class="top-left"
                />
                <img
                  src="../img/corners3/top-right-corner.svg"
                  class="top-right"
                />
                <img
                  src="../img/corners3/bottom-left-corner.svg"
                  class="bottom-left"
                />
                <img
                  src="../img/corners3/bottom-right-corner.svg"
                  class="bottom-right"
                />
                <div class="preview">
                  <img :src="imgDomain + item.img" class="img" />
                </div>
                <div class="desc name">{{ item.title }}</div>
                <div class="price-container">
                  <div class="price">
                    <span class="desc big">{{ item.price }}</span>
                    <img src="../img/coin.svg" class="coin" />
                  </div>
                  <div class="price desc">
                    <span>{{ item.price }}</span>
                    <span>{{ $parent.currency }}</span>
                  </div>
                </div>

                <a
                  class="delete link"
                  @click="$parent.removeFromCart(item.item_id)"
                >
                  <img src="./../img/delete.svg" class="img" />
                </a>
              </div>

              <a class="desc link" @click="$parent.clearCart()">
                <span class="yellow">Clear cart</span>
              </a>
            </div>
            <div class="total">
              <img src="../img/corners3/top-left-corner.svg" class="top-left" />
              <img
                src="../img/corners3/top-right-corner.svg"
                class="top-right"
              />
              <img
                src="../img/corners3/bottom-left-corner.svg"
                class="bottom-left"
              />
              <img
                src="../img/corners3/bottom-right-corner.svg"
                class="bottom-right"
              />
              <div class="title dark">PAYMENT</div>
              <div class="text">
                <div class="desc big dark">
                  <b>TOTAL:</b>
                </div>
                <div class="desc big dark">
                  <b>
                    {{ $parent.totalSum }}
                  </b>
                  <b>
                    {{ currency }}
                  </b>
                  <b>/</b>
                  <b>
                    {{ $parent.totalSum }}
                  </b>
                  <b>
                    <img src="../img/coin.svg" class="coin" />
                  </b>
                </div>
              </div>
              <button class="button" @click="$parent.openOrderCartModal()">
                BUY
              </button>
              <div class="balance-block">
                <div class="desc dark">
                  <b>MY BALANCE:</b>
                </div>
                <div class="balance-block-wrapper">
                  <img src="../img/walletDark.svg" class="img" />
                  <div class="desc big dark amount">
                    <b>{{ $parent.profileData.balance }} </b>

                    <img src="../img/coin.svg" class="coin" />
                  </div>
                  <div class="button" @click="$parent.openTopUpModal">
                    TOP UP
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Cart",
  props: ["currency"],
  components: {},
  data: function () {
    return {
      imgDomain: "",
      countryOptions: [],
      name: "",
      surname: "",
      phone: "",
      email: "",
      address: "",
      city: "",
      country: "",
      postCode: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getProfile();
    this.getCounties();
    if (this.$route.query.amount) {
      this.$emit("setAmount", this.$route.query.amount);
    }
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  methods: {
    submit() {
      let amount = this.$parent.amount;
      let data = {
        first_name: this.name,
        last_name: this.surname,
        phone: this.phone,
        email: this.email,
        country_id: this.country,
        city: this.city,
        address: this.address,
        zip: this.postCode,
        amount: amount,
      };
      this.$emit("topUp", data);
    },
    getProfile() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
  },
};
</script>
